import { Component, ViewChild } from '@angular/core';
import {
  InformationDto,
  ProcessInformationDto,
} from '../../../dto/justino/information.dto';
import { EntidadDTO } from '../../tramites/models/entidadDTO';
import { ModalEditarInfoDocsEntComponent } from '../modal-editar-info-docs-ent/modal-editar-info-docs-ent.component';
import { TramiteService } from '../../../services/tramite.service';
import { GestionInformacionService } from '../../../services/gestion-informacion.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { FileUploadService } from '../../../services/file-upload.service';
import { DominioService } from '../../../services/dominio.service';
import { ActivatedRoute } from '@angular/router';
import { DominioDto } from '../../../dto/justino/dominio.dto';
import { Constants } from '../../../constants/constants';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-gestion-informacion',
  templateUrl: './gestion-informacion.component.html',
  styleUrl: './gestion-informacion.component.scss',
})
export class GestionInformacionComponent {
  entityId: number | null = null;
  entity: EntidadDTO | undefined = undefined;
  processes: ProcessInformationDto[] = [];
  documentalInfoRegisters: InformationDto[] = [];
  documentalInfoRegistersFiltered: InformationDto[] = [];
  isDragging = false;
  selectedProcess: ProcessInformationDto | null = null;
  currentPage: number = 1;
  itemsPerPage: number = 5;
  totalItems: number = 0;
  modalUpdateDocInfo: boolean = false;
  documentalInfoRegister: InformationDto | null = null;

  @ViewChild(ModalEditarInfoDocsEntComponent)
  modalEditarInfoDocsEnt!: ModalEditarInfoDocsEntComponent;

  @ViewChild('processSelect') processSelect: any;

  constructor(
    private readonly tramiteService: TramiteService,
    private readonly gestionInformacionService: GestionInformacionService,
    private readonly alertService: AlertaModalService,
    private readonly spinnerService: SpinnerService,
    private readonly fileUploadService: FileUploadService,
    private readonly dominioService: DominioService,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(params => {
      this.entityId = +params.get('idEntidad')!;
      this.getEntity(this.entityId);
      this.getEntityProcesses(this.entityId);
      this.getDocuemtalInfoRegisters(this.entityId);
    });

    this.gestionInformacionService.informatioSubject$.subscribe(() =>
      this.getDocuemtalInfoRegisters(this.entityId!)
    );
  }

  getEntity(id: number): void {
    this.tramiteService.listaEntidadesYTramites().subscribe(res => {
      this.entity = res.find(e => e.Id === id);
    });
  }

  getEntityProcesses(entityId: number): void {
    this.gestionInformacionService.getProcesses(entityId).subscribe({
      next: res => {
        this.processes = res;
      },
      error: err => {
        this.alertService.error(
          `Error al obtener los procesos: ${err.statusText}`
        );
      },
    });
  }

  getDocuemtalInfoRegisters(entityId: number): void {
    this.gestionInformacionService
      .getDocumentalInfoRegisters(entityId)
      .subscribe({
        next: res => {
          this.documentalInfoRegisters = res;
          this.totalItems = res.length;
          this.documentalInfoRegistersFiltered = res.slice(
            0,
            this.itemsPerPage
          );
          this.selectedProcess = null;
          if (this.processSelect) {
            this.processSelect.nativeElement.selectedIndex = 0;
          }
          this.currentPage = 1;
        },
        error: err => {
          this.alertService.error(
            `Error al obtener los registros de información documental: ${err.statusText}`
          );
        },
      });
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  checkIfFileIsPdf(file: File): boolean {
    return file.type === 'application/pdf';
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (this.checkIfFileIsPdf(file)) {
        this.uploadFileProcess(file);
      } else {
        this.alertService.error('El archivo debe ser de tipo PDF (.pdf)');
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      input.value = '';
      this.uploadFileProcess(file);
    }
  }

  async uploadFileProcess(file: any): Promise<void> {
    if (this.selectedProcess === null) {
      this.alertService.error(
        'Por favor, seleccione un proceso antes de cargar el archivo.'
      );
      return;
    }

    const domainName =
      `${this.entity?.Entidad}-${this.selectedProcess?.ProcessName}-${file.name}`.replace(
        /\s+/g,
        '-'
      );
    const domainDescription = `Archivo ${file.name} para el proceso ${this.selectedProcess?.ProcessName} de la entidad ${this.entity?.Entidad}`;
    const domain = this.createDomainObject(domainName, domainDescription);
    const createdDomain: DominioDto | null = await this.createDomain(domain);

    if (createdDomain === null) {
      this.alertService.error(
        'Error al crear el dominio. Por favor, inténtelo de nuevo.'
      );
      return;
    }

    let fileCharged = false;
    let datasetId: string | null = null;

    this.fileUploadService
      .fileToBase64(file)
      .then(base64 => {
        console.log(createdDomain.Id);
        this.fileUploadService
          .uploadDomainFile(base64, createdDomain.Id)
          .subscribe({
            next: res => {
              this.spinnerService.hideSpinner();
              fileCharged = true;
              const data: any = res;
              datasetId = data.Id;

              if (!fileCharged) {
                this.deleteDomainOnFileUploadError(createdDomain.Id);
                return;
              }

              const userData = JSON.parse(
                sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ??
                  '{}'
              );

              const information: InformationDto = {
                CreatedAt: new Date().toISOString(),
                CreatedBy: userData.username,
                DatasetId: datasetId!,
                FileName: file.name,
                State: 0,
                ProcessTypeId: this.selectedProcess?.Id!,
                DomainId: createdDomain!.Id,
              };

              this.createDocumentalInfoRegister(information, file);
            },
            error: () => {
              this.spinnerService.hideSpinner();
            },
          });
      })
      .catch(error => {
        console.error('Error converting file to Base64:', error.error);
      });
  }

  createDocumentalInfoRegister(information: InformationDto, file: any): void {
    this.gestionInformacionService
      .createDocumentalInfoRegister(information)
      .subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            `El archivo ${file.name} fue cargado correctamente.`
          );
          this.getDocuemtalInfoRegisters(this.entityId!);
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(`Error al cargar el archivo: ${err.error}`);
        },
      });
  }

  async deleteDomainOnFileUploadError(domainId: string): Promise<void> {
    try {
      lastValueFrom(this.dominioService.deleteDominio(domainId));
      this.spinnerService.hideSpinner();
      this.alertService.error(
        'Error al cargar el archivo. Dominio eliminado correctamente.'
      );
    } catch (err) {
      this.spinnerService.hideSpinner();
      this.alertService.error(
        'Error al eliminar el dominio. Por favor, inténtelo de nuevo.'
      );
      return;
    }
  }

  createDomainObject(name: string, description: string): DominioDto {
    return {
      Id: '0',
      ParentId: '0',
      Nombre: name,
      Descripcion: description,
      Estado: 'Activo',
      Indexado: true,
      FechaCreacion: new Date().toISOString(),
      FechaModificacion: new Date().toISOString(),
      UsuarioCreacion: 'admin',
      UsuarioModificacion: 'admin',
      SubDominios: [],
    };
  }

  async createDomain(domain: DominioDto): Promise<DominioDto | null> {
    try {
      const createdDomain = await lastValueFrom(
        this.dominioService.createDominio(domain)
      );
      return createdDomain;
    } catch (err) {
      return null;
    }
  }

  async deleteDocumentalInfoRegister(register: InformationDto): Promise<void> {
    this.alertService.confirmacion(
      '¿Desea eliminar el registro de información documental?',
      'Eliminar',
      async () => {
        const dominioId = register.DomainId;

        const deletedDomain: boolean =
          await this.deleteDocumentalInfoRegisterDomain(dominioId);

        if (!deletedDomain) {
          this.alertService.error(
            'Error al eliminar el dominio. Por favor, inténtelo de nuevo.'
          );
          return;
        }

        this.deleteDocumentalRegisterOnRelationalDatabase(register.Id!);
      },
      () => {}
    );
  }

  async deleteDocumentalInfoRegisterDomain(domainId: string): Promise<boolean> {
    try {
      await lastValueFrom(this.dominioService.deleteDominio(domainId));
      this.spinnerService.hideSpinner();
      return true;
    } catch (error) {
      this.spinnerService.hideSpinner();
      this.alertService.error(
        'Error al eliminar el dominio. Por favor, inténtelo de nuevo.'
      );
      return false;
    }
  }

  deleteDocumentalRegisterOnRelationalDatabase(registerId: number): void {
    this.gestionInformacionService
      .deleteDocumentalInfoRegister(registerId)
      .subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Registro de información documental eliminado.'
          );
          this.getDocuemtalInfoRegisters(this.entityId!);
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(
            `Error al eliminar el registro: ${err.statusText}`
          );
        },
      });
  }

  onProcessSelected(event: any): void {
    const selectedProcessId = event.target.value;
    this.selectedProcess = this.processes.find(
      p => p.Id === +selectedProcessId
    )!;
    this.currentPage = 1;
    this.filterAndPaginateData(+selectedProcessId);
  }

  filterAndPaginateData(processId: number): void {
    const filteredData = processId
      ? this.documentalInfoRegisters.filter(
          info => info.ProcessTypeId === processId
        )
      : this.documentalInfoRegisters;

    this.totalItems = filteredData.length;

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.documentalInfoRegistersFiltered = filteredData.slice(
      startIndex,
      endIndex
    );
  }

  pageChanged(page: number): void {
    if (this.currentPage === page) return;

    this.currentPage = page;

    const filteredData = this.selectedProcess
      ? this.documentalInfoRegisters.filter(
          info => info.ProcessTypeId === this.selectedProcess!.Id
        )
      : this.documentalInfoRegisters;

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.documentalInfoRegistersFiltered = filteredData.slice(
      startIndex,
      endIndex
    );
  }

  getPages(): number[] {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    const visiblePages = 5;
    const pages: number[] = [];

    let startPage = Math.max(
      1,
      this.currentPage - Math.floor(visiblePages / 2)
    );
    let endPage = Math.min(totalPages, startPage + visiblePages - 1);

    if (endPage - startPage + 1 < visiblePages) {
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  getMinValue(a: number, b: number): number {
    return Math.min(a, b);
  }

  async updateDocInfo(register: InformationDto) {
    this.documentalInfoRegister = register;
    this.openUpdateModal();
  }

  openUpdateModal() {
    this.modalUpdateDocInfo = true;
    setTimeout(() => {
      this.modalEditarInfoDocsEnt.abrirCerrarModal();
    }, 500);
  }
}
